import { SessionFilter } from "./session-filter.module";
import { SessionEventListeners } from "./session-event-listeners.module";
import { SessionReshuffler } from "./session-reshuffler.module";
import { SessionDetails } from "./session-details.module";

export class SessionModule {
  constructor(sessionBlock) {
    this.activeFilters = {
      dates: [],
      themes: [],
      categories: [],
    };

    this.initialize(sessionBlock);
  }

  initialize(sessionBlock) {
    this.sessionBlock = sessionBlock;
    if (!this.sessionBlock) return;

    // Main container elements
    this.container = this.sessionBlock.querySelector(".sessions");
    this.sidebar = this.sessionBlock.querySelector(".sessions__sidebar");
    this.target = this.sessionBlock.querySelector(".sessions__target");
    this.timeslots = this.sessionBlock.querySelectorAll(".sessions__timeslot");
    this.notFound = this.sessionBlock.querySelector(".sessions__not-found");

    // Session items
    this.sessions = this.sessionBlock.querySelectorAll(".session");

    // Filter elements
    this.filters = sessionBlock.querySelector(".sessions__filters");
    this.filterButtons = this.filters.querySelectorAll(
      ".session__filter-button"
    );
    this.filterRows = this.filters.querySelectorAll(".sessions__filter-row");
    this.reshuffleButton = this.filters.querySelector(".session__shuffle");

    // Initialize submodules
    this.filter = new SessionFilter(this);
    this.eventListeners = new SessionEventListeners(this);
    this.reshuffler = new SessionReshuffler(this);
    this.details = new SessionDetails(this);

    // Add event listeners
    this.eventListeners.addAllEventListeners();

    // Initial render
    this.render();
  }

  set(key, value) {
    // Update the state and re-render
    this[key] = value;
    this.render();
  }

  render(onRender = null) {
    // If there are no dates selected, set the first date as active
    if (this.activeFilters.dates.length == 0) {
      this.filter.setInitialDate();
      return;
    }

    this.filter.updateFilterButtons();

    this.container.classList.remove("sessions--loaded");

    setTimeout(() => {
      this.filter.updateSessionVisibility();
      this.filter.toggleTimeslots();

      if (onRender) onRender();

      this.container.classList.add("sessions--loaded");
    }, 200);
  }
}
